// extracted by mini-css-extract-plugin
export default {"map":"Map_map__1zV02"};